class PaymentOptionsService {

    async GetPayment(summary) {
        let response = {}
        try {
            const site = window.__pt.settings.site;
            const culture = window.__pt.cultureData;
            let params = {
                channel: site.channel,
                currency: site.currency,
                language: culture?.internalCultureCode,
                PurchaseAmount: summary.totalRate.totalAmount,
                ProductType: 1,
                SurchargeRestriction: 0,
                NoRestrictions: false,
                SurchargeMargin: summary.totalRate.margin
            }

            let query = Object.keys(params)
                .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
                .join('&');
            response = await fetch(`${site.endPoints.paymentMethodUrl}?${query}`).then(response => response.json());
        } catch {
            response = null;
        }
        
        return response;
    }

}

export const PaymentOptionsServices = new PaymentOptionsService();